import { SETTING_SELECTOR_OPTIONS } from '../SETTING_SELECTOR_OPTIONS';
import { SettingSelectorOptionIdType } from '../types';

const DEFAULT_ID: SettingSelectorOptionIdType = 'spontaneous_tinder_date';
const DEFAULT_TITLE = SETTING_SELECTOR_OPTIONS[2].title; // spontaneous_tinder_date option

export const getSettingSelectorChoiceIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): SettingSelectorOptionIdType | null => {
  const id = SETTING_SELECTOR_OPTIONS.find(
    (option) => option.title === title,
  )?.id;

  if (id) {
    return id;
  }

  if (withDefault) {
    return DEFAULT_ID;
  }

  return null;
};

export const getSettingSelectorChoiceTitleById = (
  id: SettingSelectorOptionIdType | null | undefined,
  withDefault = false,
): string | null => {
  const title = SETTING_SELECTOR_OPTIONS.find(
    (option) => option.id === id,
  )?.title;

  if (title) {
    return title;
  }

  if (withDefault) {
    return DEFAULT_TITLE;
  }

  return null;
};
